// İSG uzmanı portalı — Ziyaretçiler (Visits) erişim kapısı (route guard UX).
//
// Asıl yetki backend'dedir (`[ModuleAction("visits", …)]`); bu kapı yalnız UX'tir:
// erişim sondasının (useVisitsAccess) sonucuna göre Ziyaretçiler kabuğunu, 403 sayfasını
// veya "kullanılamıyor" durumunu gösterir. `granted` → Ziyaretçiler kabuğu (Outlet).
// Ayarlar/Admin kapılarıyla aynı desen; iş modülü olarak AYRIDIR.

import { Button, Card, CardContent, Spinner } from '@isgportal/shared';
import { TriangleAlert, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useVisitsAccess } from '../../lib/visitsAccess';
import { VisitorsShell } from './VisitorsShell';

export function VisitorsGate() {
  const { t } = useTranslation();
  const access = useVisitsAccess();

  if (access.status === 'loading') {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Spinner label={t('visitors.gate.loadingLabel')} />
      </div>
    );
  }

  if (access.status === 'forbidden') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <Users className="h-10 w-10 text-danger" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('visitors.forbidden.title')}</h1>
              <p className="text-sm text-muted">{t('visitors.forbidden.body')}</p>
            </div>
            <Button asChild variant="secondary">
              <Link to="/">{t('visitors.forbidden.back')}</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (access.status === 'unavailable') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <TriangleAlert className="h-10 w-10 text-warning-foreground" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('visitors.unavailable.title')}</h1>
              <p className="text-sm text-muted">{t('visitors.unavailable.body')}</p>
            </div>
            <Button onClick={access.refetch}>{t('visitors.unavailable.retry')}</Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <VisitorsShell />;
}
